import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';

interface PlpPathParts {
  locale: string | undefined;
  plpType: PlpRoot;
  typeSpecificFilters: string | undefined;
  filtersSlug: string | undefined;
  queryStr: string | undefined;
}

const getPartsFromPlpPath = (plpPath: string) => {
  const parts: PlpPathParts = {
    locale: undefined,
    plpType: 'used',
    typeSpecificFilters: undefined,
    filtersSlug: undefined,
    queryStr: undefined,
  };

  const hasSlash = plpPath.startsWith('/');
  const searchParts = (hasSlash ? plpPath : `/${plpPath}`).split('?');
  const slashParts = searchParts[0].split('/');
  const plpTypePos = 2;
  let filtersSlugPos = plpTypePos + 1;

  parts.plpType = slashParts[plpTypePos];

  if (parts.typeSpecificFilters) {
    const typeSpecificFiltersParts = parts.typeSpecificFilters.split('/').length;
    filtersSlugPos = filtersSlugPos += typeSpecificFiltersParts;
  }

  if (slashParts[filtersSlugPos]) {
    parts.filtersSlug = slashParts.slice(filtersSlugPos).join('/');
  }

  if (searchParts[1]) {
    parts.queryStr = searchParts[1];
  }

  return parts;
};

export { getPartsFromPlpPath };
